import * as React from 'react';
import { TooltipHost, getTheme, Position, SpinButton } from '@fluentui/react';
import { AdminContext } from 'Store/Admin';
import { ValidationMessage } from './rules/ValidationMessage';
import { settingsFieldStyles } from './SettingsStyles';
import { useEffect } from 'react';

interface ConfigFieldProps {
  id: string;
  label: string;
  tooltip: string;
}

export const DEFAULT_MAX_MEDIA_HEIGHT = 500;

export const MediaHeightField: React.FC<ConfigFieldProps> = props => {
  const { palette, fonts } = getTheme();

  const { state, dispatch } = React.useContext(AdminContext);
  const [value, setValue] = React.useState<string>('');
  const [showError, setError] = React.useState<boolean>(false);

  useEffect(() => {
    if (state.queueDataState) {
      setValue(String(state.queueDataState.uxPreferences.subjectImage.maxHeight));
    }
  }, [state.queueDataState]);

  const onComponentChange = (tmpValue: string): void => {
    const numValue = Number(tmpValue);
    setError(!(numValue <= DEFAULT_MAX_MEDIA_HEIGHT));
    setValue(tmpValue);

    if (!isNaN(numValue)) {
      dispatch({
        type: 'MAX_MEDIA_HEIGHT',
        payload: Number(tmpValue)
      });
    }

    // If within range, set updated to true so user can save, else set it to false
    dispatch({
      type: 'IS_UPDATED',
      payload: numValue <= DEFAULT_MAX_MEDIA_HEIGHT
    });
  };

  return (
    <TooltipHost content={props.tooltip}>
      <SpinButton
        label="Height"
        labelPosition={Position.top}
        max={DEFAULT_MAX_MEDIA_HEIGHT}
        step={10}
        incrementButtonAriaLabel="Increase value by 10"
        decrementButtonAriaLabel="Decrease value by 10"
        value={value}
        onChange={(e, newvalue): void => onComponentChange(newvalue || '0')}
        styles={settingsFieldStyles(palette, fonts, 60)}
      />
      {showError && <ValidationMessage message={'Bad Height'} fonts={fonts} />}
    </TooltipHost>
  );
};
